import { ReactNode, CSSProperties } from 'react';

interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * FeatureCard Component
 *
 * Displays a feature with icon, title, and description.
 * Icon has subtle float animation on hover.
 */
export function FeatureCard({ icon, title, description, className = '', style }: FeatureCardProps) {
  return (
    <div className={`landing-feature ${className}`} style={style}>
      <div className="landing-feature__icon animate-float">{icon}</div>
      <h3 className="landing-feature__title">{title}</h3>
      <p className="landing-feature__description">{description}</p>
    </div>
  );
}
